import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';


@Component({
  template: `
    <ion-list radio-group [(ngModel)]="lang">
      <ion-item class="popover-text-athelas"  >
        <ion-label>French</ion-label>
        <ion-radio value="fr" (ionSelect)="close()"></ion-radio>
      </ion-item>
      <ion-item class="popover-text-charter" >
        <ion-label>English</ion-label>
        <ion-radio value="en" (ionSelect)="close()"></ion-radio>
      </ion-item>
    </ion-list>
  `
})
export class LangPage {
  lang = 'fr';
  constructor(public viewCtrl: ViewController,private translate: TranslateService) {}

  close() {
    console.log("close click",this.lang);
    this.translate.use(this.lang);
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/lang/lang.ts